module.exports = __webpack_public_path__ + "06bbd3188b34820cd83a0e0b3d0a6f57.woff2";